/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo, FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail.js.map